import React from 'react';
import { ChevronDown } from 'lucide-react';

const EnterpriseSelector = ({ locked, enterprises, selectedEnterprise, onChange }) => {
  if (locked) {
    const enterprise = enterprises.find((ent) => Number(ent.id) === Number(selectedEnterprise));
    return (
      <div>
        <span className="block text-xs font-medium text-gray-700 mb-1">Enterprise</span>
        <p className="text-sm font-medium text-gray-900" data-testid="enterprise-name">
          {enterprise?.name || ''}
        </p>
      </div>
    );  
  }

  return (
    <div className="relative">
      <label className="block text-xs font-medium text-gray-700 mb-1">Enterprise</label>
      <select
        value={selectedEnterprise || ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
        className="block w-full pl-3 pr-10 py-2 text-sm border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-lg shadow-sm appearance-none bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="">Select Enterprise</option>
        {enterprises.map((ent) => (
          <option key={ent.id} value={ent.id}>
            {ent.name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500 mt-5">
        <ChevronDown className="h-4 w-4" />
      </div>
    </div>
  );
};

export default EnterpriseSelector;
